import useOutputReportStore from "../../store/OutputReport.store";
import { getReportType } from "../../utils/helpers/dataTable";

import "./staticPageReport.scss";

import StaticPageFour from "./StaticPageFour";
import StaticPageOne from "./StaticPageOne";
import StaticPageThree from "./StaticPageThree";
import StaticPageTwo from "./StaticPageTwo";

const StaticPageReport = ({ className }) => {
  const data = useOutputReportStore((state) => state.data);
  const reportType = getReportType(data);

  return (
    <>
      <StaticPageOne />
      <StaticPageTwo />

      {reportType === "transition" && (
        <>
          <StaticPageThree />
          <StaticPageFour />
        </>
      )}
    </>
  );
};

export default StaticPageReport;
